// import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { uniqueId } from 'lodash';
import api from '../../api';

import { Company } from './types';

export async function getCompaniesRequest(
  search: string,
  page: string,
  size: string,
) {
  try {
    const response = await api().get('/companies', {
      params: {
        search,
        page,
        size,
      },
    });

    return response;
  } catch (error) {
    console.error('Error getCompaniesRequest', error);
    return null;
  }
}

export async function getCompaniesByAccountIdRequest(accountId: string) {
  try {
    const response = await api().get(`/companies/account/${accountId}`);

    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getCompanyByIdRequest(companyId: string) {
  try {
    const response = await api().get(`/companies/${companyId}`);

    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getCompaniesByUserIdRequest(
  userId: string,
  search: string,
  page: string,
  size: string,
) {
  try {
    const clientApi = await api();
    const response = await clientApi.get(`/companies/user/${userId}`, {
      params: {
        search,
        page,
        size,
      },
    });
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getCompaniesByUserIdOnDetailsBoardsRequest(
  userId: string,
  search: string,
  page: string,
  size: string,
) {
  try {
    const clientApi = await api();
    const response = await clientApi.get(
      `/companies/detail-boards/user/${userId}`,
      {
        params: {
          search,
          page,
          size,
        },
      },
    );
    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function createCompanyRequest(company: Partial<Company>) {
  try {
    const response = await api().post('/companies', {
      ...company,
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}

export async function updateCompanyRequest(
  company: Partial<Company>,
  companyId: string,
) {
  try {
    const response = await api().patch(`/companies/${companyId}`, {
      ...company,
    });

    toast.success('Empresa salva com sucesso');
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }

    console.error(error);
    return null;
  }
}

export async function removeCompanyRequest(companyId: string) {
  try {
    const response = await api().patch(`/companies/remove/${companyId}`);

    return response;
  } catch (error: any) {
    console.error(error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function activeCompanyRequest(companyId: string) {
  try {
    const response = await api().patch(`/companies/active/${companyId}`);

    return response;
  } catch (error: any) {
    console.error(error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function deleteCompanyRequest(companyId: string) {
  try {
    const response = await api().delete(`/companies/${companyId}`);

    return response.data;
  } catch (error: any) {
    console.error(error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function updateUserProfileOnCompanyRequest(
  id: string,
  userId: string,
  profile: string,
  ownerId: string,
) {
  try {
    const response = await api().patch(
      `/companies/user-profile/${id}/${userId}`,
      {},
      {
        headers: {
          profile,
          ownerId,
        },
      },
    );
    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    console.error(error);
    return null;
  }
}
